<template>
  <div id="app">
    <div id="black_over" :style="{display: showBlackOver}"></div>
    <head-box :bannerInfo="bannerInfo"></head-box>
    <nav-bar></nav-bar>
    <keep-alive>
      <router-view/>
    </keep-alive>
    <footer-nav-bar></footer-nav-bar>
    <login></login>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar'
import FooterNavBar from '@/components/FooterNavBar'
import HeadBox from '@/components/HeadBox'
import Login from '@/components/Login'
import { isMobile } from '@/utils/tools'

export default {
  name: 'App',
  components: {
    Login,
    NavBar,
    HeadBox,
    FooterNavBar
  },
  data () {
    return {
      bannerInfo: {
        'banner_img': '123',
        'title': '白金岛游戏'
      }
    }
  },
  methods: {
    _isMobile () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    }
  },
  computed: {
    showBlackOver () {
      return this.$store.state.showBlackOver
    }
  },
  mounted () {
    if (this._isMobile()) {
      location.href = 'https://wx.52bjd.com/wapdownload/mobile_wapdownload/index'
    }
  }
}
</script>

<style scoped>
/*遮罩层*/
#black_over {
    display: block;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #000000c7;
    z-index: 999999;
    opacity: 0.8;
    filter: alpha(opacity=50);
}

</style>



// WEBPACK FOOTER //
// src/App.vue